import React from 'react'
import { Grid } from '@mui/material'
import useStyle from './Styles';
import { Movie } from '..'; 
const MovieList = ({ movies, numberOfRows,excludeFirst }) => {
    const classes = useStyle();
    const startIndex = excludeFirst ? 1 : 0;
  return (
      <div>
          <Grid container className={classes.moviesContainer}>
              {movies.results.slice(excludeFirst, numberOfRows).map((movie, i) => (
                  <Movie key={i} movie={movie} i={i}/>
              ))}
          </Grid>
    </div>
  )
}

export default MovieList